import { ToothView } from '../../Enums/ToothView.enum';
import { ToothPlacement } from '../../Enums/ToothPlacement.enum';
import { ToothSide } from '../../../../graphql/graphql';

const SIDES = {
	[ToothView.BUCCAL]: {
		[ToothSide.Left]: ToothPlacement.BUCCAL_LEFT,
		[ToothSide.Right]: ToothPlacement.BUCCAL_RIGHT,
	},
	[ToothView.LINGUAL]: {
		[ToothSide.Left]: ToothPlacement.LINGUAL_LEFT,
		[ToothSide.Right]: ToothPlacement.LINGUAL_RIGHT,
	},
	[ToothView.PALATAL]: {
		[ToothSide.Left]: ToothPlacement.PALATAL_LEFT,
		[ToothSide.Right]: ToothPlacement.PALATAL_RIGHT,
	},
};

export default function getPeriodontalPlacement(
	toothView: ToothView,
	toothSide?: ToothSide,
) {
	if (!toothSide) {
		return undefined;
	}

	return SIDES[toothView as keyof typeof SIDES]?.[toothSide];
}
